import React from "react";

const RateBar = (props) => {
  return (
    <div className="rate-bar marquee ">
      {/* <p>USD/AED = 3.673     USD/AUD = 1.334     USD/AZN = 1.701     USD/BTC = 0.0000288215     USD/CAD = 1.247     USD/CHF = 0.923     USD/CNY = 6.469     USD/DKK = 6.272     USD/EUR = 0.843     USD/GBP = 0.725     USD/INR = 74.241     USD/IQD = 1464.239     USD/JPY = 109.813     USD/MYR = 4.150     USD/NOK = 8.680</p> */}
      <p> {props?.message} </p>
    </div>
  );
};

export default RateBar;
